import { Button, ButtonProps, IconButton, IconButtonProps } from "@mui/material";
import { Link } from "react-router-dom";
import styled from "styled-components";

type Props = {
    link?: string;
    icon?: boolean;
} & ButtonProps &
    IconButtonProps;

export const SoecoButton = (props: Props) => {
    return (
        <>
            {props.link ? (
                <ButtonLink to={props.link}>
                    <StyledButton
                        className={props.className}
                        variant={"contained"}
                        color={props.color ? props.color : "primary"}
                        onClick={props.onClick}
                        sx={{
                            color:
                                props.color === "warning"
                                    ? "#8c8c8c"
                                    : props.color === "primary"
                                    ? "white"
                                    : props.color === "secondary"
                                    ? "black"
                                    : "white",
                            textTransform: props.color === "warning" ? "none" : "uppercase",
                            fontFamily: "'Inter', sans-serif",
                            fontWeight: "500",
                            fontSize: "16px",
                        }}
                        fullWidth={props.fullWidth}
                        {...props}
                    >
                        {props.children}
                    </StyledButton>
                </ButtonLink>
            ) : props.icon ? (
                <StyledIconButton
                    className={props.className}
                    color={props.color ? props.color : "primary"}
                    onClick={props.onClick}
                    disabled={props.disabled}
                    aria-label={props["aria-label"]}
                    title={props.title}
                    size={props.size}
                >
                    {props.children}
                </StyledIconButton>
            ) : (
                <StyledButton
                    className={props.className}
                    variant={"contained"}
                    disabled={props.disabled}
                    color={props.color ? props.color : "primary"}
                    onClick={props.onClick}
                    sx={{
                        color:
                            props.color === "warning"
                                ? "#8c8c8c"
                                : props.color === "primary"
                                ? "white"
                                : props.color === "secondary"
                                ? "black"
                                : "white",
                        textTransform: props.color === "warning" ? "none" : "uppercase",
                        fontFamily: "'Inter', sans-serif",
                        fontWeight: "500",
                        fontSize: "16px",
                    }}
                    fullWidth={props.fullWidth}
                    size={props.size}
                    form={props.form}
                    type={props.type}
                    {...props}
                >
                    {props.children}
                </StyledButton>
            )}
        </>
    );
};

const ButtonLink = styled(Link)`
    text-decoration: none;
`;

const StyledIconButton = styled(IconButton)`
    text-decoration: none;
`;

const StyledButton = styled(Button)`
    color: white;
`;
